import { createAction } from "typesafe-actions"

import { WebSocketTypes } from "library/common/types/webSocketTypes"

export const connect = createAction(WebSocketTypes.CONNECT)<string>()
